// Copyright (c) 2016 Deere & Company

import DuplicatePinPlate from '../../../reports/duplicate-pin-plate/state-connector';

export default {
    component: DuplicatePinPlate,
    name: 'DUPLICATE_PIN_PLATE',
    path: 'duplicate-pin-plate-report'
};



// WEBPACK FOOTER //
// ./src/routes/products/reports/duplicate-pin-plate.js